import { defineNuxtPlugin } from '#app'
import { BotInstance, botDirective } from '@/components/navigation/Bot'

export default defineNuxtPlugin((nuxtApp) => {
	nuxtApp.provide('bot', BotInstance)
	nuxtApp.vueApp.directive('bot', botDirective)
})
